module.exports = __webpack_public_path__ + "img/stripe_logo_gray.a3dc7945.svg";